import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { spinnerAnimation } from '../../assets/lottie';
import { useDimension } from '../../hooks/use-dimension';
import { WidgetSize } from './WidgetSize.type';

export interface CountdownWidgetStateClassStartingProps {
  size?: WidgetSize;
  isThin?: boolean;
}

export const CountdownWidgetStateClassStarting: React.FC<
  CountdownWidgetStateClassStartingProps
> = ({ isThin, size }) => {
  const __ = useTranslation().t;

  const title = __('gettingReady');
  const subtitle = __('classAboutToStart');
  const { width } = useDimension();

  if (size === 'sm') {
    return (
      <BannerContainer>
        <BannerTextContainer>
          <Title sm>{title}</Title>
          <Subtitle sm>{subtitle}</Subtitle>
        </BannerTextContainer>
        <Lottie
          animationData={spinnerAnimation}
          style={{
            position: 'absolute',
            height: '74px',
            right: width < 576 ? '-36px' : '0px',
          }}
        />
      </BannerContainer>
    );
  }

  return (
    <Container>
      <Title>{title}</Title>
      {!isThin && <StyledHr />}
      <Subtitle isThin={isThin}>{subtitle}</Subtitle>
      <ImageWrapper>
        <Lottie animationData={spinnerAnimation} style={{ height: '70px' }} />
      </ImageWrapper>
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
`;

interface TitleProps {
  sm?: boolean;
}

const Title = styled.h6<TitleProps>`
  font-family: 'Inter';
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.dark};

  ${({ sm, theme }) =>
    sm
      ? `
      @media screen and (max-width: ${theme.screenSizes.xs}) {
        font-size: 10px;
        line-height: 12px;
      }
  `
      : ``}
`;

const StyledHr = styled.hr`
  margin: 12px 0;
  border: 1px solid ${({ theme }) => theme.colors.backgroundDark};
`;

interface SubtitleProps {
  isThin?: boolean;
  sm?: boolean;
}

const Subtitle = styled.p<SubtitleProps>`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #444444;
  ${({ sm }) => (sm ? `` : `text-align: center;`)}
  margin-top: ${({ isThin, sm }) => (sm ? `0` : isThin ? `4px` : `16px`)};
  margin-bottom: ${({ isThin }) => (isThin ? `6px!important` : `0`)};

  ${({ sm, theme }) =>
    sm
      ? `
      @media screen and (max-width: ${theme.screenSizes.xs}) {
        font-size: 14px;
        line-height: 20px;
      }
  `
      : ``}
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  max-width: 410px;
  position: relative;
  margin: auto;
`;

const BannerTextContainer = styled.div`
  flex: 1;
`;
